<template>
  <v-row no-gutters>
    <v-col class="pt-4" style="max-width: 100%;">
      <template v-for="element in elements">
        <template v-if="element.element_type === 'attribute_holder'">
          <feature-card-data-row
            v-bind="{ ...$props, ...$attrs, ...element }"
            :key="element.attribute"
            :value="{ ...value }[element.attribute]"
            @change="onChange($event, element.attribute)"
            @input="onChange($event, element.attribute)"
          />
        </template>
        <template v-else>
          <sidebar-row :key="element.label" class="pr-5 pt-2">
            <template #default>
              <v-subheader class="text-left text-body-2 font-weight-medium font--text pa-0" style="height: auto">
                {{ element.label }}
              </v-subheader>
            </template>
          </sidebar-row>
          <feature-card-data
            v-bind="{ ...$props, ...$attrs }"
            :elements="element.elements"
            :value="value"
            v-on="$listeners"
            :key="`${element.label}_elements`"
          ></feature-card-data>
        </template>
      </template>
    </v-col>
  </v-row>
</template>

<script>
import FeatureCardDataRow from '@/components/FeatureCardDataRow';
import SidebarRow from '@/components/SidebarRow.vue';

export default {
  name: 'FeatureCardData',
  components: {
    FeatureCardDataRow,
    SidebarRow,
  },
  model: {
    event: 'change',
  },
  props: {
    isEditingOn: {
      type: Boolean,
      default: false,
    },
    elements: {
      type: Array,
      required: true,
    },
    value: {
      type: Object,
      required: true,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChange(value, key) {
      this.$emit('change', { ...this.value, [key]: value });
    },
  },
};
</script>

<style lang="scss" scoped></style>
